/**
 * @function parseStyles
 * Parses a string of inline styles into a javascript object with casing for react
 *
 * @from https://gist.github.com/goldhand/70de06a3bdbdb51565878ad1ee37e92b
 * @param {string} styles
 * @returns {Object}
 */
const parseStyles = (styles) =>
    styles
        .split(';')
        .filter((style) => style.split(':')[0] && style.split(':')[1])
        .map((style) => [
            style
                .split(':')[0]
                .trim()
                .replace(/-./g, (c) => c.substr(1).toUpperCase()),
            style.split(':').slice(1).join(':').trim()
        ])
        .reduce(
            (styleObj, style) => ({
                ...styleObj,
                [style[0]]: style[1]
            }),
            {}
        )

export default parseStyles
